import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from 'lucide-react';
// =============================================================================
// STAT CARD COMPONENT
// =============================================================================
export function StatCard({ label, value, subtitle, subtitleColor = 'var(--cc-accent-strong)', onClick, }) {
    return (_jsxs("div", { onClick: onClick, className: "cc-hover-lift", style: {
            border: '1px solid var(--cc-border)',
            borderRadius: 12,
            padding: '12px 14px',
            background: 'var(--cc-elevated)',
            boxShadow: 'var(--cc-card-shadow)',
            cursor: onClick ? 'pointer' : 'default',
        }, children: [_jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }, children: [_jsx("span", { style: {
                            fontSize: 11,
                            fontWeight: 700,
                            color: 'var(--cc-text-3)',
                            textTransform: 'uppercase',
                            letterSpacing: '0.6px',
                        }, children: label }), onClick && (_jsx(ChevronRight, { size: 14, style: { color: 'var(--cc-text-3)' } }))] }), _jsx("div", { style: {
                    fontSize: 25,
                    fontWeight: 800,
                    lineHeight: 1.1,
                    marginTop: 6,
                    fontFamily: "'JetBrains Mono', monospace",
                    letterSpacing: '-0.02em',
                    color: 'var(--cc-text)',
                }, children: value }), subtitle && (_jsx("div", { style: {
                    fontSize: 11.5,
                    fontWeight: 700,
                    marginTop: 3,
                    color: subtitleColor,
                }, children: subtitle }))] }));
}
// =============================================================================
// STAT STRIP (4 cards in a row)
// =============================================================================
export function StatStrip({ stats }) {
    return (_jsx("div", { style: {
            display: 'grid',
            // auto-fit: 4-up where there's room, wrapping down to 1-up on
            // phones instead of ~90px unreadable tiles (slice 7b, both apps)
            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
            gap: 11,
        }, children: stats.map((stat, index) => (_jsx(StatCard, { label: stat.label, value: stat.value, subtitle: stat.subtitle, subtitleColor: stat.color, onClick: stat.onClick }, index))) }));
}
export default StatCard;
